import { Field, Float, InputType, ObjectType, registerEnumType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { QuestionTypeEnum } from '../enums/QuestionTypeEnum'
import { AnswerKeyMethodEnum } from '../enums/AnswerKeyMethodEnum'

// Registered beside the fields that use them so the enum files stay decorator-free for the mobile apps.
registerEnumType(AnswerKeyMethodEnum, {
  name: 'AnswerKeyMethodEnum',
  description: 'How an answer key was created',
})

@ObjectType()
@InputType('AnswerKeyItemInput')
export class AnswerKeyItem {
  @Field(() => Float)
  @Prop({ type: Number, required: true })
  questionNumber: number

  @Field(() => QuestionTypeEnum)
  @Prop({ type: String, enum: QuestionTypeEnum, required: true })
  questionType: QuestionTypeEnum

  /**
   * Nullable because an Open row has no correct answer — Mongoose's string
   * `required` validator rejects the empty string outright, so this cannot
   * stay `required: true` once a row can carry no answer at all.
   */
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  correctAnswer?: string

  @Field(() => Float)
  @Prop({ type: Number, default: 1 })
  points: number

  /**
   * Inclusive last item number of an open range, with questionNumber as the
   * first — absent on every other question type. Derived server-side by
   * SaveAnswerKey as questionNumber + points - 1; never taken from the client.
   */
  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  endQuestion?: number
}

@ObjectType()
@InputType('AnswerKeyInput')
export class AnswerKey {
  @Field(() => AnswerKeyMethodEnum)
  @Prop({ type: String, enum: AnswerKeyMethodEnum, required: true })
  createdMethod: AnswerKeyMethodEnum

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  sourceImageUrl?: string

  @Field(() => [AnswerKeyItem])
  @Prop({ type: [AnswerKeyItem] }, PropType.ARRAY)
  items: ReturnType<() => AnswerKeyItem[]>
}
